export enum DocumentType {
  LOGO = 'LOGO',
  PICTURE = 'PICTURE',
  DOCUMENT = 'DOCUMENT'
}
